import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Row, Glyphicon, Button } from 'react-bootstrap';

import FormSectionStatus from './FormSectionStatus';
import { DegreeValidation } from "../validation/professionalValidation";
import { updateDegree  } from '../actions';
import { degreeLevels, statusTypes } from '../config/constants';

class Degree extends Component {
  constructor(props){
    super(props);
    this.handleDegreeChanges = this.handleDegreeChanges.bind(this);
    this.handleDegreeNameChange = this.handleDegreeNameChange.bind(this);
    this.handleDegreeSchoolChange = this.handleDegreeSchoolChange.bind(this);
    this.handleDegreeLevelChange = this.handleDegreeLevelChange.bind(this);
    this.handleDegreeDateChange = this.handleDegreeDateChange.bind(this);
    this.handleRemoveDegree = this.handleRemoveDegree.bind(this);
    this.handleDeltaAppliedChange = this.handleDeltaAppliedChange.bind(this);
  }

  handleDegreeNameChange(e){
    const updates = { name: e.target.value };
    this.handleDegreeChanges(updates);
  }

  handleDegreeSchoolChange(e){
    const updates = { school: e.target.value };
    this.handleDegreeChanges(updates);
  }

  handleDegreeLevelChange(e){
    const updates = { level: e.target.value };
    this.handleDegreeChanges(updates);
  }

  handleDegreeDateChange(e){
    const updates = { date: e.target.value };
    this.handleDegreeChanges(updates);
  }

  handleDegreeChanges(updates){
    const {dispatch, id} = this.props;
    dispatch(updateDegree(id, updates));
  }

  handleDeltaAppliedChange(e){
    const updates = { deltaApplied: e.target.checked };
    this.handleDegreeChanges(updates);
  }

  handleRemoveDegree(e){
    e.preventDefault();
    this.props.onRemoveDegree(this.props.id);
  }

  render() {
    const { id, name, school, level, date, deltaApplied, colleges } = this.props;
    const space = ' ';
    const validationState = new DegreeValidation(colleges).getValidationStatus(this.props);

    const selectedCollege = colleges.find(c => c.id === school);
    const isDeltaCollege = selectedCollege && /delta/i.test(selectedCollege.name);

    const getLevelOptions = () => {
      return Object.keys(degreeLevels).map((level) => {
        return (
          <option key={level} value={level}>{degreeLevels[level]}</option>
        )
      });
    };

    const getCollegeOptions = () => {
      if(colleges.length < 1)
        return <option value="">Add Colleges in Education Info</option>;

      return [(<option value="" key="0">Select</option>)].concat(colleges.map((college) => {
        return (
          <option key={college.id} value={college.id}>{college.name}</option>
        )
      }));
    };

    const getSectionStatus = () => {
      return validationState.section.status === statusTypes.SUCCESS ? null : <FormSectionStatus {...validationState.section}/>;
    };

    return (
      <React.Fragment>
        <Row>
          <Col md={3}>
            <FormGroup
              controlId={`degree-${id}-name`}
            >
              <ControlLabel>
                Degree
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={name}
                placeholder="Enter Degree Name"
                onChange={this.handleDegreeNameChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId={`degree-${id}-school`}
            >
              <ControlLabel>
                School
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={school}
                onChange={this.handleDegreeSchoolChange}>
                { getCollegeOptions() }
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup
              controlId={`degree-${id}-level`}
            >
              <ControlLabel>
                Level
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={level}
                onChange={this.handleDegreeLevelChange}>
                <option value="">Select</option>
                {getLevelOptions()}
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId={`degree-${id}-date`}
            >
              <ControlLabel>
                Date
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="date"
                value={date}
                placeholder="Enter Date"
                onChange={this.handleDegreeDateChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup
              controlId={`degree-${id}-remove`}
            >
              <ControlLabel>
                Remove
              </ControlLabel>
              <Button bsStyle="danger"
                      onClick={this.handleRemoveDegree}
                      style={{width: '100%'}}>
                <Glyphicon glyph="trash"/>
                {space}
              </Button>
            </FormGroup>
          </Col>
        </Row>
        {isDeltaCollege &&
        <Row>
          <Col md={12}>
            <FormGroup controlId={`degree-${id}-deltaApplied`}>
              <div>
                <input
                  type="checkbox"
                  checked={!!deltaApplied}
                  onChange={this.handleDeltaAppliedChange}
                />{' '}
                <span>I have applied for this Delta College degree but have not yet been awarded it.</span>
              </div>
            </FormGroup>
          </Col>
        </Row>
        }
        <div className="clearfix"></div>
        {getSectionStatus()}
      </React.Fragment>
    );
  };
}

export default Degree;